import { defineComponent as _defineComponent } from 'vue'
import type { Package } from '@/@types/graphql-types';
import { useConstantStore } from '@/stores/pinia/useConstantStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProviderIcon',
  props: {
    providerId: { default: 1 },
    providerShortName: null,
    lazy: { type: Boolean, default: true },
    size: { default: 'icon' },
    iconUrl: { default: null },
    forceWide: { type: Boolean, default: false },
    forceAvif: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { providerId: Package['packageId'], providerShortName?: Package['shortName'], lazy: boolean, size: 'icon' | 'small', iconUrl: string | null, forceWide: boolean, forceAvif: boolean };

const PROVIDER_FALLBACK_NAME = 'JustWatch';
const FALLBACK_ICON = 'https://static.justwatch.com/static/compile_jw/assets/jw-icon-badge.png';

const profiles = {
	icon: 's100',
	small: 's40',
} as const;



const constantStore = useConstantStore();

const provider: Package | undefined = (() => {
	if (props.providerShortName != null) {
		return (constantStore.allProvidersByShortName as Record<Package['shortName'], Package>)[
			props.providerShortName
		];
	} else if (props.providerId != null) {
		return (constantStore.allProvidersById as Record<Package['shortName'], Package>)[props.providerId];
	}
	return undefined;
})();

const providerClearName = provider?.clearName ?? PROVIDER_FALLBACK_NAME;

const iconUrlRaw = (() => {
	let icon = props.iconUrl ?? provider?.icon;

	if (!icon) return FALLBACK_ICON;

	if (icon.startsWith('/')) {
		icon = `${JW_CONFIG.IMAGESCALER_URL}${icon.replace('{profile}', profiles[props.size])}`;
	}

	return icon;
})();

const isWideIcon = (() => props.forceWide || iconUrlRaw.includes('icon_wide'))();

// in case the campaign icon override is PNG we don't render the webp and avif sources for transparency
const isPng = iconUrlRaw.endsWith('.png');

const imageUrl = iconUrlRaw.replace('{format}', 'jpeg');

const webpImageUrl = iconUrlRaw.replace('{format}', 'webp');
const avifImageUrl = (() => {
	if (props.forceAvif && !iconUrlRaw.includes('{format}')) {
		return iconUrlRaw.replace(/\.\w+$/, '.avif');
	}
	return iconUrlRaw.replace('{format}', 'avif');
})();

return { __sfc: true,PROVIDER_FALLBACK_NAME, FALLBACK_ICON, profiles, props, constantStore, provider, providerClearName, iconUrlRaw, isWideIcon, isPng, imageUrl, webpImageUrl, avifImageUrl }
}

})